import * as React from "react";
import styled, { css } from "styled-components";

import { Text } from "src/library/components/Text/Text";

import { CreditStatus } from "../api/support.api";

interface IProps {
  status: CreditStatus;
}

interface IStatusWrapper {
  status: CreditStatus;
}

const StatusWrapper = styled(Text)<IStatusWrapper>`
  font-weight: ${({ theme }) => theme.fonts.weights.bold};
  color: ${({ theme }) => theme.colors.darkGrey};
  ${({ status }) => StatusCss(status)};
`;

const DefaultCss = css`
  color: inherit;
`;

const ApprovedCss = css`
  color: ${({ theme }) => theme.colors.success};
`;

const ResolvedCss = css`
  color: ${({ theme }) => theme.colors.success};
`;

const RequiresReviewCss = css`
  color: ${({ theme }) => theme.colors.warn}
`;

// Gives the status the appropriate colour
const StatusCss = (status: CreditStatus) => {
  switch (status) {
    case CreditStatus.Reviewed:
      return ApprovedCss;
    case CreditStatus.AutoReviewed:
      return ApprovedCss;
    case CreditStatus.RequiresReview:
      return RequiresReviewCss;
    case CreditStatus.Resolved:
      return ResolvedCss;
    default:
      return DefaultCss;
  }
};

export const creditStatusTextSwitch = (status: CreditStatus): string => {
  switch (status) {
    case CreditStatus.Reviewed:
      return "Reviewed";
    case CreditStatus.AutoReviewed:
      return "Auto-approved";
    case CreditStatus.RequiresReview:
      return "Requires review";
    case CreditStatus.Resolved:
      return "Resolved";
    default:
      return "";
  }
};

/**
 * Gets the credit status styled
 */
const CreditStatusStyled: React.ReactFCWithChildren<IProps> = ({ status }) => {
  const statusText = React.useMemo(() => {
    return creditStatusTextSwitch(status);
  }, [ status ]);

  return (
    <StatusWrapper status={status}>
      {statusText}
    </StatusWrapper>
  );
};

export default CreditStatusStyled;
